"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeoutConstants = exports.errorConstants = exports.EnsureDependenciesErrorConfiguration = exports.UninstallErrorConfiguration = exports.AcquireErrorConfiguration = void 0;
exports.callWithErrorHandling = callWithErrorHandling;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const fs = require("fs");
const open = require("open");
const DotnetCoreAcquisitionWorker_1 = require("../Acquisition/DotnetCoreAcquisitionWorker");
const DotnetInstall_1 = require("../Acquisition/DotnetInstall");
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const InstallIdUtilities_1 = require("./InstallIdUtilities");
const IssueReporter_1 = require("./IssueReporter");
var AcquireErrorConfiguration;
(function (AcquireErrorConfiguration) {
    AcquireErrorConfiguration[AcquireErrorConfiguration["DisplayAllErrorPopups"] = 0] = "DisplayAllErrorPopups";
    AcquireErrorConfiguration[AcquireErrorConfiguration["DisableErrorPopups"] = 1] = "DisableErrorPopups";
})(AcquireErrorConfiguration || (exports.AcquireErrorConfiguration = AcquireErrorConfiguration = {}));
var UninstallErrorConfiguration;
(function (UninstallErrorConfiguration) {
    UninstallErrorConfiguration[UninstallErrorConfiguration["DisplayAllErrorPopups"] = 0] = "DisplayAllErrorPopups";
    UninstallErrorConfiguration[UninstallErrorConfiguration["DisableErrorPopups"] = 1] = "DisableErrorPopups";
})(UninstallErrorConfiguration || (exports.UninstallErrorConfiguration = UninstallErrorConfiguration = {}));
var EnsureDependenciesErrorConfiguration;
(function (EnsureDependenciesErrorConfiguration) {
    EnsureDependenciesErrorConfiguration[EnsureDependenciesErrorConfiguration["DisplayAllErrorPopups"] = 0] = "DisplayAllErrorPopups";
    EnsureDependenciesErrorConfiguration[EnsureDependenciesErrorConfiguration["DisableErrorPopups"] = 1] = "DisableErrorPopups";
})(EnsureDependenciesErrorConfiguration || (exports.EnsureDependenciesErrorConfiguration = EnsureDependenciesErrorConfiguration = {}));
var errorConstants;
(function (errorConstants) {
    errorConstants.errorMessage = 'An error occurred while installing .NET';
    errorConstants.reportOption = 'Report an issue';
    errorConstants.hideOption = 'Don\'t show again';
    errorConstants.moreInfoOption = 'More information';
    errorConstants.configureManuallyOption = 'Configure manually';
})(errorConstants || (exports.errorConstants = errorConstants = {}));
var timeoutConstants;
(function (timeoutConstants) {
    timeoutConstants.timeoutMessage = `.NET install timed out.
You should change the timeout if you have a slow connection. See: https://github.com/dotnet/vscode-dotnet-runtime/blob/main/Documentation/troubleshooting-runtime.md#install-script-timeouts.
Our CDN may be blocked in China or experience significant slowdown, in which case you should install .NET manually.`;
    timeoutConstants.moreInfoOption = 'Change Timeout Value';
})(timeoutConstants || (exports.timeoutConstants = timeoutConstants = {}));
let showMessage = true;
function callWithErrorHandling(callback, context, requestingExtensionId, acquireContext) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const isAcquisitionError = acquireContext ? true : false;
        try {
            /* eslint-disable @typescript-eslint/await-thenable */
            const result = yield callback();
            context.eventStream.post(new EventStreamEvents_1.DotnetCommandSucceeded(context.commandName));
            return result;
        }
        catch (caughtError) {
            const error = caughtError;
            if (!isCancellationStyleError(error)) {
                context.eventStream.post(isAcquisitionError ?
                    new EventStreamEvents_1.DotnetCommandFailed(error, context.commandName, (0, InstallIdUtilities_1.getInstallFromContext)(acquireContext)) :
                    // The output observer will keep track of installs and we don't want a non-install failure to make it think it should -=1 from the no. of installs
                    new EventStreamEvents_1.DotnetNotInstallRelatedCommandFailed(error, context.commandName));
            }
            if (acquireContext) {
                // Remove this when https://github.com/typescript-eslint/typescript-eslint/issues/2728 is done
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                context.eventStream.post(new EventStreamEvents_1.DotnetAcquisitionFinalError(error, (_a = (caughtError === null || caughtError === void 0 ? void 0 : caughtError.eventType)) !== null && _a !== void 0 ? _a : 'Unknown', (0, DotnetInstall_1.GetDotnetInstallInfo)(acquireContext.acquisitionContext.version, acquireContext.acquisitionContext.mode, (_b = acquireContext.acquisitionContext.installType) !== null && _b !== void 0 ? _b : 'local', (_c = acquireContext.acquisitionContext.architecture) !== null && _c !== void 0 ? _c : DotnetCoreAcquisitionWorker_1.DotnetCoreAcquisitionWorker.defaultArchitecture())));
            }
            if (context.errorConfiguration === AcquireErrorConfiguration.DisplayAllErrorPopups) {
                if (error.message.includes(timeoutConstants.timeoutMessage)) {
                    context.displayWorker.showErrorMessage(`${errorConstants.errorMessage}${context.version ? ` (${context.version})` : ''}: ${error.message}`, (response) => __awaiter(this, void 0, void 0, function* () {
                        if (response === timeoutConstants.moreInfoOption) {
                            open(context.timeoutInfoUrl).catch(() => { });
                        }
                        return Promise.resolve();
                    }), timeoutConstants.moreInfoOption);
                }
                else if (showMessage) {
                    let errorOptions = [errorConstants.reportOption, errorConstants.hideOption, errorConstants.moreInfoOption];
                    if (requestingExtensionId) {
                        errorOptions = errorOptions.concat(errorConstants.configureManuallyOption);
                    }
                    context.displayWorker.showErrorMessage(`${errorConstants.errorMessage}${context.version ? ` (${context.version})` : ''}: ${error.message}`, (response) => __awaiter(this, void 0, void 0, function* () {
                        if (response === errorConstants.moreInfoOption) {
                            open(context.moreInfoUrl).catch(() => { });
                        }
                        else if (response === errorConstants.hideOption) {
                            showMessage = false;
                        }
                        else if (response === errorConstants.reportOption) {
                            const [url, issueBody] = (0, IssueReporter_1.formatIssueUrl)(error, context);
                            context.displayWorker.copyToUserClipboard(issueBody).catch(() => { });
                            open(url).catch(() => { });
                        }
                        else if (response === errorConstants.configureManuallyOption && requestingExtensionId) {
                            yield configureManualInstall(context, requestingExtensionId);
                        }
                    }), ...errorOptions);
                }
            }
            return undefined;
        }
        finally {
            context.logger.dispose();
        }
    });
}
function configureManualInstall(context, requestingExtensionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const manualPath = yield context.displayWorker.displayPathConfigPopUp();
        if (manualPath && fs.existsSync(manualPath)) {
            try {
                yield context.extensionConfigWorker.setSharedPathConfigurationValue(manualPath);
                context.displayWorker.showInformationMessage(`Set .NET path to ${manualPath}. Please reload VSCode to apply settings.`, () => { });
            }
            catch (e) {
                context.displayWorker.showWarningMessage(`Failed to configure the path: ${e.toString()}`, () => { });
            }
        }
        else {
            context.displayWorker.showWarningMessage('Manually configured path was not valid.', () => { });
        }
    });
}
function isCancellationStyleError(error) {
    // Handle both when the event.error or event itself is posted.
    return error && error.constructor && (error.constructor.name === 'UserCancelledError' || error.constructor.name === 'EventCancellationError') ||
        error instanceof EventStreamEvents_1.DotnetInstallExpectedAbort || error instanceof EventStreamEvents_1.EventCancellationError;
}
//# sourceMappingURL=ErrorHandler.js.map